import type { Reference } from '@apollo/client';

export const mergeById = (
  existing: readonly Reference[] = [],
  incoming: readonly Reference[] = [],
  { readField }: { readField: <T>(fieldName: string, ref: Reference) => T | undefined }
) => {
  const getId = (ref: Reference) => readField<string>('id', ref);
  const existingById = new Map<string | undefined, Reference>(existing.map((ref) => [getId(ref), ref]));

  return incoming.map((ref) => existingById.get(getId(ref)) ?? ref);
};

export const mergeByUniqueProp =
  (prop: string) =>
  (existing: readonly any[] = [], incoming: readonly any[] = []) => {
    const existingByKey = new Map(existing.map((existingItem) => [existingItem?.[prop], existingItem]));

    return incoming.map((item) => {
      const prev = existingByKey.get(item?.[prop]);
      return prev ? { ...prev, ...item } : item;
    });
  };
